/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type ShopLeftNavComponent_viewer$ref = any;
export type ShopLeftNavComponentQueryVariables = {};
export type ShopLeftNavComponentQueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": ShopLeftNavComponent_viewer$ref;
    }) | null;
};
export type ShopLeftNavComponentQuery = {
    readonly response: ShopLeftNavComponentQueryResponse;
    readonly variables: ShopLeftNavComponentQueryVariables;
};



/*
query ShopLeftNavComponentQuery {
  viewer {
    id
    ...ShopLeftNavComponent_viewer
  }
}

fragment ShopLeftNavComponent_viewer on Viewer {
  user {
    id
    email
    firstName
    lastName
    role
    accountRole {
      accountRoleTitle
      id
    }
    permissions {
      id
      oneCommerce {
        id
        ceo {
          access
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ShopLeftNavComponentQuery",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "ShopLeftNavComponent_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "ShopLeftNavComponentQuery",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "firstName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "lastName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "accountRole",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "AccountRoleType",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "accountRoleTitle",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v0 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "permissions",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PermissionsType",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "oneCommerce",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OneCommerceType",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "ceo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AccessType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "access",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "ShopLeftNavComponentQuery",
            "id": null,
            "text": "query ShopLeftNavComponentQuery {\n  viewer {\n    id\n    ...ShopLeftNavComponent_viewer\n  }\n}\n\nfragment ShopLeftNavComponent_viewer on Viewer {\n  user {\n    id\n    email\n    firstName\n    lastName\n    role\n    accountRole {\n      accountRoleTitle\n      id\n    }\n    permissions {\n      id\n      oneCommerce {\n        id\n        ceo {\n          access\n        }\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'a1e54d9decc81e3751e60e0848aee710';
export default node;
